import {Component, Input} from '@angular/core';
import {AnimalModel} from 'src/app/modules/animals/models/animal.model';

@Component({
  selector: 'app-animal-in-stock-icon',
  template: `
    @if (!animal.inStock) {
      <span
        class="pi pi-info-circle not-in-stock text-lg mx-2"
        [pTooltip]="'animalAdd.general.basicData.notInStock' | transloco"
        tooltipPosition="right"
        style="color: #7e9c30;"
      >
      </span>
    }
  `,
  standalone: false
})
export class AnimalInStockIconComponent {
  @Input() animal!: AnimalModel;
}
